import HeroScreen from './HeroScreen';
import MusicalPlayerScreen from './MusicalPlayerScreen';

import QuizScreen from './QuizScreen';
import BasicQuizScreen from './BasicQuizScreen.jsx';
import InputQuizScreen from './InputQuizScreen.jsx';
import RangeQuizScreen from './RangeQuizScreen';
import MultipleQuizScreen from './MultipleQuizScreen';

import LevelsInfoScreen from './LevelsInfoScreen';
import NewLevelScreen from './NewLevelScreen.jsx';

import LessonCoverScreen from './LessonCoverScreen';
import FinalScreen from './FinalScreen.jsx';

import FractionStoryScreen from './FractionStoryScreen';
import FractionComicsIntro from '../../themes/fractions/stories/ComicsIntro.jsx';
import FractionComics1 from '../../themes/fractions/stories/ComicsPart1.jsx';
import FractionComics2 from '../../themes/fractions/stories/ComicsPart2.jsx';
import FractionComics3 from '../../themes/fractions/stories/ComicsPart3.jsx';
import FractionComics4 from '../../themes/fractions/stories/ComicsPart4.jsx';


export const SCREEN_TYPES = {
  'hero': HeroScreen,
  'musical-player': MusicalPlayerScreen,
  'quiz': QuizScreen,
  'basic-quiz': BasicQuizScreen,
  'input-quiz': InputQuizScreen,
  'range-quiz': RangeQuizScreen,
  'multiple-quiz': MultipleQuizScreen,
  'lesson-cover': LessonCoverScreen,
  'levels-info': LevelsInfoScreen,
  'new-level': NewLevelScreen,
  'final': FinalScreen,
  'fraction-story': FractionStoryScreen,
  'fraction-comics-intro': FractionComicsIntro,
  'fraction-comics-1': FractionComics1,
  'fraction-comics-2': FractionComics2,
  'fraction-comics-3': FractionComics3,
  'fraction-comics-4': FractionComics4
};